<template>
  <div style="width: 100%">
    <!-- Task Content -->
    <div class="mb-3">{{ $t('assignmentFeedback.videoTasks.watchToComplete') }}</div>
    <stemble-video v-if="renderVideo" ref="player" :youtube-video-id="task.youtubeVideoId" />
    <v-checkbox v-model="watched" :label="$t('iveWatchedTheVideo')" @change="emitResponse" />
  </div>
</template>

<script>
import {TaskCardMixin} from '../mixins/task-card';
import StembleVideo from '@/tasks/components/StembleVideo';
import Task from '@/tasks/models/Task';

export default {
  name: 'WatchVideoTask',
  components: {
    StembleVideo,
  },
  mixins: [TaskCardMixin()],
  props: {
    task: {
      type: Task,
      required: true,
    },
  },
  data() {
    return {
      watched: false,
      renderVideo: true,
    };
  },
  activated() {
    this.forceVideoRerender();
  },
  methods: {
    setResponse(response) {
      this.watched = response.content.watched;
    },
    clearResponse() {
      this.watched = false;
    },
    forceVideoRerender() {
      this.renderVideo = false;
      this.$nextTick().then(() => {
        this.renderVideo = true;
      });
    },
    emitResponse() {
      const response = {
        watched: this.watched,
      };
      this.$emit('update:inputData', response);
    },
    submitResponse() {
      let response = {
        watched: this.watched,
      };
      this.$emit('submit-response', {response});
    },
  },
};
</script>
